import {ActionList} from '@primer/react'
import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'
import type {IssueTypeEntry$key} from './__generated__/IssueTypeEntry.graphql'

type IssueTypeEntryProps = {
  issueType: IssueTypeEntry$key
  setSelectedTypeId: (issueTypeId: string) => void
  selectedTypeId: string
}

export function IssueTypeEntry({issueType, setSelectedTypeId, selectedTypeId}: IssueTypeEntryProps) {
  const {name, description, id} = useFragment(
    graphql`
      fragment IssueTypeEntry on IssueType {
        name
        description
        id
      }
    `,
    issueType,
  )

  const selected = selectedTypeId === id
  return (
    <ActionList.Item
      role="menuitemradio"
      selected={selected}
      aria-checked={selected}
      onSelect={() => setSelectedTypeId(id)}
    >
      {name}
      <ActionList.Description variant="block">{description}</ActionList.Description>
    </ActionList.Item>
  )
}

try{ IssueTypeEntry.displayName ||= 'IssueTypeEntry' } catch {}